// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgClosemaxi24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.2803 4.78033C20.5732 4.48744 20.5732 4.01256 20.2803 3.71967C19.9874 3.42678 19.5126 3.42678 19.2197 3.71967L13.5 9.438V5.91667C13.5 5.50245 13.1642 5.16667 12.75 5.16667C12.3358 5.16667 12 5.50245 12 5.91667V11.25C12 11.6642 12.3358 12 12.75 12H18.0833C18.4975 12 18.8333 11.6642 18.8333 11.25L18.8265 11.1482C18.7768 10.7822 18.463 10.5 18.0833 10.5L14.561 10.499L20.2803 4.78033ZM12 12.75C12 12.3358 11.6642 12 11.25 12H5.91667C5.50245 12 5.16667 12.3358 5.16667 12.75L5.17351 12.8518C5.22318 13.2178 5.53697 13.5 5.91667 13.5H9.438L3.71967 19.2197C3.42678 19.5126 3.42678 19.9874 3.71967 20.2803C4.01256 20.5732 4.48744 20.5732 4.78033 20.2803L10.499 14.561L10.5 18.0833C10.5 18.4975 10.8358 18.8333 11.25 18.8333C11.6642 18.8333 12 18.4975 12 18.0833V12.75Z"
				/>
			</Svg>
		);
	}
);
SvgClosemaxi24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgClosemaxi24;
